import { Grid, Typography } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import messages from '@src/routes/SemiConfigurators/messages'
import { Specifications as SpecificationsType } from '@src/types/graphql-types'
import { checkValidKey } from '@src/routes/Configurators/utils/util'
import useFormikHelper from '../../useFormikHelper'

const useStyles = makeStyles((theme: Theme) => {
  return {
    categoryDisplay: {
      display: 'inline',
    },
    // TODO move the common CSS in styled component for Title
    titleStyle: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 900,
      textTransform: 'uppercase',
      display: 'inline',
    },
    specItemContainer: {
      marginTop: theme.spacing(5),
    },
    roomTemperatureStyle: {
      display: 'inline',
    },
    disabledCategoryDisplay: {
      color: theme.palette.grey[400],
    },
    disabledTitle: {
      color: theme.palette.grey[500],
    },
  }
})

interface ShippingOptionsProps {
  specifications: SpecificationsType[]
}

const ShippingOptions: React.FC<ShippingOptionsProps> = ({
  specifications,
}) => {
  const classes = useStyles()
  const formik = useFormikHelper()
  const isSequenceValid =
    formik.selectedOligoValues.sequence !== '' &&
    (!formik.errors || formik.errors?.sequence === '')
  return (
    <Grid container>
      <Grid item xs={6}>
        <Typography
          className={`${classes.titleStyle} ${
            !isSequenceValid ? classes.disabledTitle : ''
          }`}
        >
          <FormattedMessage
            id="CONF_SHIPPING_EASY_OLIGO"
            defaultMessage="Shipping Options"
          />
        </Typography>
        <Grid container className={classes.specItemContainer}>
          <Grid item xs={12}>
            {specifications[0].specificationModifications?.map((option) => {
              return (
                <Grid item xs={12} key={option.value}>
                  <Typography
                    className={`${classes.categoryDisplay} ${
                      !isSequenceValid ? classes.disabledCategoryDisplay : ''
                    }`}
                  >
                    <FormattedMessage
                      {...checkValidKey(
                        messages[option.displayName],
                        option.displayName
                      )}
                    />
                  </Typography>
                  <Typography
                    className={`${classes.roomTemperatureStyle} ${
                      !isSequenceValid ? classes.disabledCategoryDisplay : ''
                    }`}
                  >
                    <FormattedMessage
                      id="CONF_ROOM_TEMPERATURE_EASY_OLIGO"
                      defaultMessage="(Room Temperature)"
                    />
                  </Typography>
                </Grid>
              )
            })}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ShippingOptions
